import { render, staticRenderFns } from "./VcTwoCascade.vue?vue&type=template&id=8e883cfe&scoped=true"
import script from "./VcTwoCascade.vue?vue&type=script&lang=js"
export * from "./VcTwoCascade.vue?vue&type=script&lang=js"
import style0 from "./VcTwoCascade.vue?vue&type=style&index=0&id=8e883cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e883cfe",
  null
  
)

export default component.exports